// extracted by mini-css-extract-plugin
export default {"apps":"apps_apps__uz5yH","app_slide":"apps_app_slide__cezSL","app_logo":"apps_app_logo__jL2rF"};